/**
 * Redirects to base url if the organizer flag is not set (ENABLE_ORGANIZERS env var)
 * @param {*} context
 */
export default function ({ $config, redirect }) {
  if (!$config.features.enableOrganizers) return redirect('/');
}
